const cachedScripts: {[key: string]: Promise<unknown>} = {};

export function loadScript(src: string) {
    const existing = cachedScripts[src];

    if (existing){
        return existing;
    }

    const promise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;

        const onScriptLoad = () => {
            resolve(true);
        }

        const onScriptError = () => {
            cleanup();

            delete cachedScripts[src];
            script.remove();

            reject(new Error(`Unable to load script ${src}`));
        }

        script.addEventListener('load', onScriptLoad);
        script.addEventListener('error', onScriptError);

        document.body.appendChild(script);

        function cleanup() {
            script.removeEventListener('load', onScriptLoad);
            script.removeEventListener('error', onScriptError);
        }
    });

    cachedScripts[src] = promise;
    return promise;
}
